export var cuePointsToBreaks=function(t){return t.map((function(t){var r=t.end,a=t.played,e=t.start;return{duration:r-e,isWatched:a,startTime:e}}))};